module.exports = __webpack_public_path__ + "img/undo.25d31ac7.svg";